/* import __COLOCATED_TEMPLATE__ from './post.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();